import { useQuery } from '@tanstack/react-query'
import InsightsAPI from '@/features/dashboard/api/insights/InsightsAPI'
import { QUERY } from '@/features/dashboard/api/insights/InsightsAPI.model'

interface DishesQueryProps {
  first_start_date: string
  first_end_date: string
  second_start_date: string
  second_end_date: string
}

export function useDishesInsightsQuery(props: DishesQueryProps) {
  const {
    first_start_date,
    first_end_date,
    second_start_date,
    second_end_date
  } = props

  const params = {
    first_start_date,
    first_end_date,
    second_start_date,
    second_end_date
  }

  const totalSalesValueDishes = useQuery({
    queryKey: [QUERY.TOTAL_SALES_VALUE_DISHES, params],
    queryFn: () => InsightsAPI.getTotalSalesValueDishes(params)
  }).data

  const totalSalesCountDishes = useQuery({
    queryKey: [QUERY.TOTAL_SALES_COUNT_DISHES, params],
    queryFn: () => InsightsAPI.getTotalSalesCountDishes(params)
  }).data

  const totalSalesAveragesDishes = useQuery({
    queryKey: [QUERY.TOTAL_SALES_AVERAGES_DISHES, params],
    queryFn: () => InsightsAPI.getTotalSalesAveragesDishes(params)
  }).data

  const totalSalesCumulativeValueDishes = useQuery({
    queryKey: [QUERY.TOTAL_SALES_CUMULATIVE_VALUE_DISHES, params],
    queryFn: () => InsightsAPI.getTotalSalesCumulativeValueDishes(params)
  }).data

  return {
    totalSalesValueDishes,
    totalSalesCountDishes,
    totalSalesAveragesDishes,
    totalSalesCumulativeValueDishes
  }
}
